import { render } from "./Words.vue?vue&type=template&id=393a92a8&scoped=true&ts=true"
import script from "./Words.vue?vue&type=script&lang=ts"
export * from "./Words.vue?vue&type=script&lang=ts"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-393a92a8"]])

export default __exports__